// extracted by mini-css-extract-plugin
export default {"VehicleSettingsBox":"qZ_zx","VehicleSettingsBoxContent":"kYXpE","critAirLine":"x0LUE"};